import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const sessionId = searchParams.get('session_id');
  const courseId = searchParams.get('course_id');
  const token = localStorage.getItem('token');

  useEffect(() => {
    if (!sessionId || !courseId || !token) {
      navigate('/');
      return;
    }
    confirmPurchase();
  }, []);

  const confirmPurchase = async () => {
    try {
      await axios.post(
        `${API}/purchases/confirm?session_id=${sessionId}&course_id=${courseId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Course purchased successfully!');
    } catch (error) {
      console.error('Error confirming purchase:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen pt-32 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-600">Confirming your purchase...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-32 pb-24 flex items-center justify-center" data-testid="payment-success-page">
      <div className="max-w-2xl w-full px-6">
        <div className="bg-white rounded-3xl p-12 shadow-2xl border border-slate-100 text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
          <h1 className="text-4xl font-extrabold text-slate-900 mb-4">Payment Successful!</h1>
          <p className="text-lg text-slate-600 mb-8">
            Congratulations! You've successfully enrolled in the course. Start learning now!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to={`/course-player/${courseId}`} data-testid="start-learning-button">
              <button className="btn-primary flex items-center gap-2">
                Start Learning <ArrowRight className="w-5 h-5" />
              </button>
            </Link>
            <Link to="/dashboard" data-testid="go-to-dashboard-button">
              <button className="btn-secondary">Go to Dashboard</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentSuccessPage;
